export const TaskAssistantEndpoints = {
  Query: 'api/TaskAssistant/Query',
  SeedMainSchema: 'api/TaskAssistant/SeedMainSchema',
  SeedSiteSchema: 'api/TaskAssistant/SeedSiteSchema',
};
